import React from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';

import LayoutAdmin from '@components/admin/LayoutAdmin';
import ProtectedRoute from '@components/ProtectedRoute';
import { DashboardLayout } from './layouts/DashboardLayout';

import {
  NotFound, BizManagePage,
  CompanyAssignment, Dashboard, DeliverablesManagement, VisitManagement, Login as FigmaLogin, ReferenceManagement,
  ProfileSettings, AccountManagement, MemberManagement, StaffManagement, ProgressManagement
} from '@pages';
import { AuthContext } from '@context'; // 현재 권한 확인용
import { toast } from 'react-toastify';

// 이미 로그인된 사용자가 로그인 페이지 접근 시 대시보드로 이동시키는 래퍼 컴포넌트
const PublicRedirect = ({ children }) => {
  const { auth, isLoading } = React.useContext(AuthContext);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isLoading) return;

    if (auth.isAuthenticated) {
      toast.info('이미 로그인 되어 있습니다.');
      navigate('/dashboard', { replace: true });
    }
  }, [isLoading, auth.isAuthenticated, navigate]);

  if (isLoading) return <div style={{ textAlign: 'center' }}>Loading...</div>;

  if (auth.isAuthenticated) {
    return null; // 깜빡임 및 하위 컴포넌트 렌더링 방지
  }

  return children;
};

// 로그인한 권한에 따라 첫 화면을 다르게 보내주는 컴포넌트
const IndexRedirect = () => {
  const { auth } = React.useContext(AuthContext);

  if (auth.role === 'ROLE_ADMIN') {
    return <Dashboard />; // 관리자는 대시보드로
  } else if (auth.role === 'ROLE_USER') {
    return <Dashboard />; // 일반 유저
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default function AppRoutes() {
  return (
    <Routes>

      {/* ✅ 로그인 페이지 추가 (로그인된 사용자는 접근 불가) */}
      <Route path="/login" element={<PublicRedirect><FigmaLogin /></PublicRedirect>} />

      <Route path="/" element={<DashboardLayout />}>
        {/* 🌟 루트(/) 접속 시 권한별로 첫 화면 분기 처리 */}
        <Route index element={<ProtectedRoute><IndexRedirect /></ProtectedRoute>} />

        {/*  하위 주소들 */}
        <Route path="dashboard" element={<ProtectedRoute roles={["ROLE_USER", "ROLE_ADMIN"]}><Dashboard /></ProtectedRoute>} />
        <Route path="member-management" element={<ProtectedRoute roles={["ROLE_ADMIN"]}><MemberManagement /></ProtectedRoute>} />
        <Route path="staff-management" element={<ProtectedRoute roles={["ROLE_ADMIN"]}><StaffManagement /></ProtectedRoute>} />
        <Route path="company" element={<ProtectedRoute roles={["ROLE_ADMIN"]}><BizManagePage /></ProtectedRoute>} />
        <Route path="company-assignment" element={<ProtectedRoute roles={["ROLE_USER", "ROLE_ADMIN"]}><CompanyAssignment /></ProtectedRoute>} />
        <Route path="progress" element={<ProtectedRoute roles={["ROLE_ADMIN"]}><ProgressManagement /></ProtectedRoute>} />
        <Route path="visit-management" element={<ProtectedRoute roles={["ROLE_USER", "ROLE_ADMIN"]}><VisitManagement /></ProtectedRoute>} />
        <Route path="deliverables" element={<ProtectedRoute roles={["ROLE_USER", "ROLE_ADMIN"]}><DeliverablesManagement /></ProtectedRoute>} />
        <Route path="reference" element={<ProtectedRoute roles={["ROLE_USER", "ROLE_ADMIN"]}><ReferenceManagement /></ProtectedRoute>} />
        <Route path="profile" element={<ProtectedRoute roles={["ROLE_USER", "ROLE_ADMIN"]}><ProfileSettings /></ProtectedRoute>} />
        <Route path="account" element={<ProtectedRoute roles={["ROLE_USER", "ROLE_ADMIN"]}><AccountManagement /></ProtectedRoute>} />
      </Route>

      {/* <Route
        path="/master"
        element={
          <ProtectedRoute roles={['ROLE_ADMIN']}>
            <LayoutAdmin />
          </ProtectedRoute>
        }
      >
        
      </Route> */}


      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}